import { IS_LOCALHOST, ENV } from './config.js';

export const LOGO_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};

/**
 * Branding Logo
 */
export default function FetchLogo( companyId, type = LOGO_TYPE.PRIMARY ) {
    if ( IS_LOCALHOST ) {
        return `https://${ ENV }api.biw.cloud/v1/branding/companies/${ encodeURIComponent( companyId ) }/logos/${ encodeURIComponent( type ) }`;
    }
    return `https://${ window.location.hostname }/api/v1/branding/companies/${ encodeURIComponent( companyId ) }/logos/${ encodeURIComponent( type ) }`;

}
